// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"FootNote__Wrapper__5pSD","Inner":"FootNote__Inner_21Otx","Digit":"FootNote__Digit_r-rK3"};